export const isProNetworkListing = listing => {
  return listing?.attributes?.publicData?.listingType === 'pro-network';
};

const priceRangeLabelId = amount => {
  if (amount >= 200000) {
    return 'ProNetworkPricing.range2000Plus';
  } else if (amount >= 150000) {
    return 'ProNetworkPricing.range1500Plus';
  } else if (amount >= 100000) {
    return 'ProNetworkPricing.range1000Plus';
  } else if (amount >= 50000) {
    return 'ProNetworkPricing.range500Plus';
  } else if (amount >= 100) {
    return 'ProNetworkPricing.lowMinimum';
  }

  return 'ProNetworkPricing.lowMinimum';
};

export const getProNetworkPriceLabel = (listing, intl) => {
  if (!isProNetworkListing(listing)) {
    return null;
  }

  const minimumPricingType = listing?.attributes?.publicData?.minimumPricingType || 'numeric';
  if (minimumPricingType === 'none') {
    return intl.formatMessage({ id: 'ProNetworkPricing.none' });
  }
  if (minimumPricingType === 'custom') {
    return intl.formatMessage({ id: 'ProNetworkPricing.custom' });
  }

  const amount = listing?.attributes?.price?.amount;
  if (typeof amount !== 'number') {
    return null;
  }

  return intl.formatMessage({ id: priceRangeLabelId(amount) });
};
